import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=050f0d52&scoped=true"
import script from "./TaskOverview.vue?vue&type=script&lang=ts"
export * from "./TaskOverview.vue?vue&type=script&lang=ts"
import style0 from "./TaskOverview.vue?vue&type=style&index=0&id=050f0d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f0d52",
  null
  
)

export default component.exports